/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardrails_Section_2_DInputs */



/**
* | output |
* | --- |
* | "False negatives may occur, where problematic requests are not detected" |
*
* @param {Guardrails_Section_2_DInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const guardrails_section_2_d = /** @type {((inputs?: Guardrails_Section_2_DInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardrails_Section_2_DInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("FALSE NEGATIVES auftreten können, bei denen problematische Anfragen nicht erkannt werden")
	return /** @type {LocalizedString} */ ("False negatives may occur, where problematic requests are not detected")
});